import DestinationData from "../Destination Data/DestinationData";
import "./Destination.css";
const MaldivesImg1 =
  "https://images.unsplash.com/photo-1578922746465-3a80a228f223?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=627&q=80";
const MaldivesImg2 =
  "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80";
const RegisImg1 =
  "https://s7d1.scene7.com/is/image/marriotts7prod/xr-dohxr-hotel-exterior-26188-29816:Classic-Hor?wid=1215&fit=constrain";
const RegisImg2 =
  "https://s7d1.scene7.com/is/image/marriotts7prod/xr-dohxr-granddeluxe-1069016116-55827:Classic-Hor?wid=1215&fit=constrain";
function Destination() {
  return (
    <div className="destination">
      <h1>Popular Destinations</h1>
      <p>Tours give you the opportunity to see a lot,within a time frame</p>
      <DestinationData
        className="first-des"
        heading="Maldives, South Asia"
        text="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui aut
            quae labore voluptatum rerum, distinctio ratione optio sed in,
            suscipit vero, velit possimus a quibusdam quasi. Illo nam esse ipsum
            obcaecati voluptate consequatur corrupti officia expedita. Deserunt
            cumque voluptatum, reprehenderit consectetur perspiciatis quae
            tempore itaque illo. Laudantium maiores repudiandae nihil!"
        img1={MaldivesImg1}
        img2={MaldivesImg2}
      />
      <DestinationData
        className="first-des-reverse"
        heading=" Regis Doha, Qatar"
        text="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui aut
            quae labore voluptatum rerum, distinctio ratione optio sed in,
            suscipit vero, velit possimus a quibusdam quasi. Illo nam esse ipsum
            obcaecati voluptate consequatur corrupti officia expedita. Deserunt
            cumque voluptatum, reprehenderit consectetur perspiciatis quae
            tempore itaque illo. Laudantium maiores repudiandae nihil!"
        img1={RegisImg1}
        img2={RegisImg2}
      />
    </div>
  );
}

export default Destination;
